<template>
    <div class="login take-again">
        <div style="text-align: center;">
            <h3>Ready to take TRAC again?</h3>
            <p>TRAC can be an invaluable tool for following up and assessing your progress as you run your race. We recommend you take the TRAC360&deg; Assessment again after six months to see how you&rsquo;re doing. As an existing user, you can retake the assessment for only $49.</p>
            <button class="button is-big is-secondary" @click.prevent="pay">Pay To Continue</button>
            <p class="is-small">Looking for your assesment results? <a href="/result"><em>Find them here &rarr;</em></a></p>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

export default {
    name: 'TakeAgain',
    components: {
    },
    data: function() {
        return {
            age: '',
            stripeHandler: null,
            config: {},
            email: '',
            submit_clicked: false
        }
    },
    mounted: async function() {
        const res = await Axios.get('/config');
        this.config = res.data;
        if (this.config.email) {
            this.email = this.config.email;
        }

        this.stripeHandler = StripeCheckout.configure({
            key: this.config.key,
            locale: 'auto',
            token: this.stripeResponse
        });
    },
    computed: {
        price: function() {
            return this.config.ta_amount;
        }
    },
    methods: {
        pay: function () {
            this.stripeHandler.open({
                name: this.config.name,
                description: this.config.description,
                amount: this.price,
                email: this.email,
                allowRememberMe: false
            });
        },
        stripeResponse: function (token) {
            // You can access the token ID with `token.id`.
            // Get the token ID to your server-side code for use.
            const router = this.$router;
            const formData = {
                stripeToken: token.id
            };
            Axios.post('/take-again', formData).then(function (response) {
                if (response.data && response.data.success) {
                    router.push('start');
                }
            });
        }
    }
}
</script>
